import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import News from "./components/News";
import SignInRoute from "./components/SignInRoute";
import NotFound from "./components/NotFound";
import { initAwsRum } from "./monitoring/awsRum";
// import { initializeChatbot } from './helpers/chatbotHelper';
import Header from "./components/Header";
import "./App.css";
import PortalDashboard from "./components/PortalDashboard";
import Help from "./components/Help";
import ProtectedRoute from "./components/ProtectedRoute";
import CpfSearch from "./components/CpfSearch";
import ClientDetailsMatter from "./components/ClientDetailsMatter";
import ClientDetailsParty from "./components/ClientDetailsParty";
import CoordinatorCoCoDetails from "./components/CoordinatorCoCoDetails";
import CoordinatorClientDetails from "./components/CoordinatorClientDetails";
import {
  CoCoAdvancedSearchRoute,
  CoordinatorGlobalSearchRoute,
} from "./components/CoordinatorGlobalSearch";
import Error from "./components/Error";
import Profile from "./components/Profile";
import AnnouncementGate from "./components/AnnouncementGate";
import WhatsAppContact from "./components/WhatsAppContact";
import { WhatsAppContactProvider } from "./context/WhatsAppContactContext";
import { useFeatureFlags } from "./context/FeatureFlagsContext";

initAwsRum();

function App() {
  const { features } = useFeatureFlags();
  // useEffect(() => {
  //   const cleanupChatbot = initializeChatbot();
  //   return () => {
  //     cleanupChatbot();
  //   };
  // }, []);

  useEffect(() => {
    document.title = "PG-CoCounsel Portal";
  }, []);

  return (
    <Router>
      <WhatsAppContactProvider>
        <Header />
        <AnnouncementGate />
        <Routes>
          <Route path="/signin" element={<SignInRoute />} />
          <Route path="/error" element={<Error />} />

          <Route path="/news" element={<ProtectedRoute element={<News />} />} />
          <Route path="/help" element={<ProtectedRoute element={<Help />} />} />
          <Route
            path="/"
            element={<ProtectedRoute element={<PortalDashboard />} />}
          />
          <Route
            path="/client-details-matter/:matterId"
            element={<ProtectedRoute element={<ClientDetailsMatter />} />}
          />
          <Route
            path="/client-details-party/:partyId"
            element={<ProtectedRoute element={<ClientDetailsParty />} />}
          />
          <Route
            path="/coordinator/search"
            element={<ProtectedRoute element={<CoordinatorGlobalSearchRoute />} />}
          />
          <Route
            path="/coordinator/:cocoId"
            element={<ProtectedRoute element={<CoordinatorCoCoDetails />} />}
          />
          <Route
            path="/coordinator/:cocoId/clients/:matterId"
            element={<ProtectedRoute element={<CoordinatorClientDetails />} />}
          />
          <Route
            path="/cpf-search"
            element={
              <ProtectedRoute
                element={
                  features.clientSearch
                    ? <Navigate to="/client-search" replace />
                    : <CpfSearch />
                }
              />
            }
          />
          <Route
            path="/client-search"
            element={
              <ProtectedRoute
                element={
                  features.clientSearch
                    ? <CpfSearch />
                    : <Navigate to="/cpf-search" replace />
                }
              />
            }
          />
          <Route
            path="/client-search/advanced"
            element={<ProtectedRoute element={<CoCoAdvancedSearchRoute />} />}
          />
          <Route
            path="/profile"
            element={<ProtectedRoute element={<Profile />} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsAppContact />
      </WhatsAppContactProvider>
    </Router>
  );
}

export default App;
